import React from 'react';
import { Image } from '../Image/Image.es.js';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import 'nanoid/non-secure';
import { Brand } from './styled.es.js';

var NavBarBrand = function NavBarBrand(_ref) {
  var src = _ref.src,
      width = _ref.width,
      height = _ref.height,
      href = _ref.href,
      onClick = _ref.onClick,
      children = _ref.children;
  return (
    /* @__PURE__ */
    React.createElement(Brand, {
      as: href ? "a" : "div",
      href: href || "",
      onClick: onClick
    }, src &&
    /* @__PURE__ */
    React.createElement(Image, {
      src: src,
      alt: "logo",
      width: width,
      height: height
    }), children && children)
  );
};

NavBarBrand.displayName = "NavBar.Brand";
export { NavBarBrand };